import React from 'react';

/**
 * The reason a viewer may not do something, or nothing while that is not known yet: permissions that are still
 * loading (or failed to load) have not said no, so "you do not have permission" would be a claim nobody has made.
 * A control gated on `allowed` stays disabled either way; only the text waits.
 */
export const deniedReason = (allowed, permissionsUnknown, reason) => (allowed || permissionsUnknown ? undefined : reason);

/**
 * Why a control is disabled, for assistive tech and keyboards (the Calendar toolbar's pattern). A `title` on a
 * disabled control is a mouse tooltip only: the control takes no focus and a screen reader does not read it. Render
 * this beside the control and point the control's `aria-describedby` at `id`; keep the `title` for the mouse.
 * Nothing renders without a reason, so the control carries no `aria-describedby` then either.
 */
export default function DisabledReason({ id, reason }) {
    return reason ? <span id={id} className="sr-only">{reason}</span> : null;
}
